import CONSTANTS from './constants';

export const newApiKeyMarkets = [CONSTANTS.BE_LRE_PL_DIMENSIONS.brand, CONSTANTS.BE_JAG_PL_DIMENSIONS.brand];
